import type {
  PublicOrderResponse,
  PublicUserResponse,
} from '@contracts/order/PublicOrderResponse';

export enum PublicOrderResultType {
  OK = 'ok',
  EXPIRED = 'expired',
}

export enum PublicOrderErrorCode {
  ACCESS_EXPIRED = 'OrderPublicAccessExpiredException',
}

export type PublicOrderResult =
  | { type: PublicOrderResultType.OK; order: PublicOrderResponse }
  | { type: PublicOrderResultType.EXPIRED; claimedBy?: PublicUserResponse };
